import { SVGProps } from 'react'

export const AnalyzePriorities = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='254'
    height='189'
    viewBox='0 0 254 189'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      x='32.0549'
      y='17.4985'
      width='204.783'
      height='46.0365'
      rx='4.3128'
      fill='#B2CAE0'
    />
    <rect
      x='73.3291'
      y='73.0598'
      width='163.509'
      height='44.449'
      rx='4.3128'
      fill='#B2CAE0'
    />
    <rect
      x='73.3291'
      y='128.621'
      width='163.509'
      height='46.0365'
      rx='4.3128'
      fill='#B2CAE0'
    />
    <rect
      x='41.5'
      y='27.5'
      width='182.559'
      height='25.3995'
      rx='3.08057'
      fill='white'
    />
    <rect
      x='78.0916'
      y='79.4097'
      width='146.047'
      height='25.3995'
      rx='3.08057'
      fill='white'
    />
    <rect
      x='78.0916'
      y='136.558'
      width='146.047'
      height='25.3995'
      rx='3.08057'
      fill='white'
    />
    <rect
      x='35.5'
      y='21'
      width='198'
      height='37'
      rx='3.8128'
      stroke='#003263'
      strokeDasharray='7.39 7.39'
    />
    <rect
      x='70.6543'
      y='68.7975'
      width='162.509'
      height='43.449'
      rx='3.8128'
      stroke='#003263'
    />
    <rect
      x='70.6543'
      y='124.359'
      width='162.509'
      height='45.0365'
      rx='3.8128'
      stroke='#003263'
    />
    <ellipse cx='47.5' cy='95.5' rx='8' ry='7' fill='#B2CAE0' />
    <ellipse cx='47.5' cy='146.5' rx='8' ry='7' fill='#B2CAE0' />
    <path
      d='M48 103C52.3852 103 56 99.6741 56 95.5C56 91.3259 52.3852 88 48 88C43.6148 88 40 91.3259 40 95.5C40 99.6741 43.6148 103 48 103Z'
      stroke='#003263'
    />
    <path
      d='M48 154C52.3852 154 56 150.674 56 146.5C56 142.326 52.3852 139 48 139C43.6148 139 40 142.326 40 146.5C40 150.674 43.6148 154 48 154Z'
      stroke='#003263'
    />
    <path
      d='M60.8917 33.6083L59.7167 34.7833C60.9167 35.9917 61.6667 37.6583 61.6667 39.5C61.6667 43.1833 58.6834 46.1667 55 46.1667C51.3167 46.1667 48.3334 43.1833 48.3334 39.5C48.3334 36.1 50.875 33.3 54.1667 32.8917V34.575C51.8 34.975 50 37.025 50 39.5C50 42.2583 52.2417 44.5 55 44.5C57.7584 44.5 60 42.2583 60 39.5C60 38.1167 59.4417 36.8667 58.5334 35.9667L57.3584 37.1417C57.9584 37.75 58.3334 38.5833 58.3334 39.5C58.3334 41.3417 56.8417 42.8333 55 42.8333C53.1584 42.8333 51.6667 41.3417 51.6667 39.5C51.6667 37.95 52.7334 36.6583 54.1667 36.2833V38.0667C53.6667 38.3583 53.3334 38.8833 53.3334 39.5C53.3334 40.4167 54.0834 41.1667 55 41.1667C55.9167 41.1667 56.6667 40.4167 56.6667 39.5C56.6667 38.8833 56.3334 38.35 55.8334 38.0667V31.1667H55C50.4 31.1667 46.6667 34.9 46.6667 39.5C46.6667 44.1 50.4 47.8333 55 47.8333C59.6 47.8333 63.3334 44.1 63.3334 39.5C63.3334 37.2 62.4 35.1167 60.8917 33.6083Z'
      fill='#75B8FB'
    />
  </svg>
)
